import React from 'react';
import { TableCellProps } from '../../../types/search';
import { formatDate } from '../utils/tableCellUtils';

const PortalCellDateIssued: React.FC<TableCellProps> = ({ value, row, listingType }) => {
  return (
    <div className={`portal-cell portal-cell--${listingType} portal-cell--date-issued`}>
      <p className="portal-cell__mobile-label">Issued</p>
      <p>{formatDate(value)}</p>
    </div>
  );
};

export default PortalCellDateIssued;
